import { gql } from "@apollo/client";
export const QUERY_FOOTER = gql`
  query QueryFooter {
    globalFooter {
      links {
        text
        url
        file {
          url
          alternativeText
        }
      }
      edwinPeoplelogo {
        url
        alternativeText
      }
      partOfLogo {
        url
      }
      bestPlacesToWorkLogo {
        url
      }
      copyright
      phone
      email
      linkedinUrl
    }
  }
`;
